<div class="map-container" style="height: 70vh;">
    <google-map
      height="100%"
      width="100%"
      [center]="center"
      [zoom]="zoom()"
      [options]="mapOptions">

      <!-- Markers are managed by MarkerClusterer in the component code -->

      <div class="map-legend">
        <h3>Total Service Providers: {{ totalServiceProviders() }}</h3>
        <h3>Available Service Providers: {{ availableServiceProviders() }}</h3>
        <h3>Unavailable Service Providers: {{ unavailableServiceProviders() }}</h3>
        <h3>Busy Service Providers: {{ busyServiceProviders() }}</h3>
        <h3>Unknown Status Service Providers: {{ unknownStatusServiceProviders() }}</h3>
      </div>
      @if (selectedServiceProvider()) {
        <div class="sp-info">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                <h4 style="margin: 0;">{{ selectedServiceProvider()?.clientName }}</h4>
                <span style="cursor: pointer; font-size: 16px;">
                    <nz-icon nzType="close" (click)="selectedServiceProvider.set(null)"></nz-icon>
                </span>
            </div>
             <p>Allocated Breakdowns (60 days): {{ selectedServiceProvider()?.breakdownsAllocated }}</p>
            <p>Available Technicians: {{ availableTechsCount() }}</p>
            <p>Offline Technicians: {{ offlineTechsCount() }}</p>
            <p>Busy Technicians: {{ busyTechsCount() }}</p>
            <h4>Contact: {{ selectedServiceProvider()?.clientTel }}</h4>
            <button  nzType="primary" (click)="requestStatusUpdate(selectedServiceProvider()!)" [disabled]="!isStatusUpdateRequestAvailable(selectedServiceProvider()!.dtLastStatusRequest)"
            [nz-tooltip]="!isStatusUpdateRequestAvailable(selectedServiceProvider()!.dtLastStatusRequest) ? 'Status update request is available every 30 minutes. Last update request was at ' + (selectedServiceProvider()!.dtLastStatusRequest + 'Z' | date:'short' | date:'shortTime') : ''">
              <span nz-icon nzType="reload" ></span>
              
                @if (!isStatusUpdateRequestAvailable(selectedServiceProvider()!.dtLastStatusRequest)) {
                Request Status Update Not Available
              } @else {
                  Request Status Update
              }
            </button>
        </div>
      }
      @if (incidentLocation()) {
      <map-marker
                [position]="{ lat: this.incidentLocation()!.latitude, lng: this.incidentLocation()!.longitude }"
                [options]="{
                  icon: getPulseIcon(),
                  zIndex: 1
                }">
        
      </map-marker>
    }
    </google-map>
</div>